import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, inject } from "@angular/core";

@Component({
    selector: "navbar-lightrope",
    templateUrl: "./navbar-lightrope.component.html",
    styleUrls: ["./navbar-lightrope.component.scss"]
})
export class NavbarLightropeComponent implements OnInit, OnChanges {
    private el = inject(ElementRef);

    @Input() visible: boolean;
    bulbs: number[] = [];

    ngOnInit() {
        this.calculateBulbs();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["visible"] && this.visible) {
            setTimeout(() => this.onResize(), 0);
        }
    }

    @HostListener("window:resize")
    onResize() {
        this.calculateBulbs();
    }

    private calculateBulbs() {
        const bulbWidth = 30;
        const containerWidth = this.el.nativeElement.offsetWidth || window.innerWidth;
        const count = Math.floor(containerWidth / bulbWidth);
        this.bulbs = Array(count).fill(0);
    }
}
